export default "__VITE_ASSET__DrdC2iJz__"